var apt: any = apt || {};
apt.timer = (function ($: JQueryStatic) {
	let _timer: number; //handle to interval polling
	let _autoSaveTimer: number; //handle to auto save
	let _pollInterval: number = 1000; //How often to check countdown (in milliseconds)
	let _ticks: number = 0; //Elapsed time on current view
	let _ticks_idle: number = 0;
	let _idlePeriodSeconds: number = 600; //Idle period before idle warning (in seconds)
	let _idleSeconds: number = 600; //Seconds spent on page before idle warning should be displayed
	let _idleMsg: string;
	let _warn1_Seconds: number = -1; //When to show warning 1 (in minutes)
	let _warn1Msg: string;
	let _warn2_Seconds: number = -1; //When to show warning 2 (in minutes)
	let _warn2Msg: string;
	let _startActivity: Date = new Date();
	let _showTimerCount: boolean = true;
	let _pageTimer: number;
	let _pageTimed: boolean = false;

	/** Timer polling */
	let _checkInterval = function () {
		let counter: number;
		let timeRemaining: number = Number($("#TimeRemaining").val());

		if ($("#IsTimed").val() === "True" && timeRemaining > 0) {
			_pageTimed = true;
			counter = timeRemaining;
			$("#timerclock").show();
			if (_showTimerCount) $("#timertext").show();
		}
		else {
			$("#timerclock, #timertext").hide().text("");
		}

		//only the below is repeated every _pollInterval
		_timer = window.setInterval(() => {
			_ticks++;
			_ticks_idle++;

			$("#Duration").val(_ticks);

			if (!isNaN(counter)) {
				counter--;
				$("#TimeRemaining").val(counter);
				//presentation message
				let minutes: number = parseInt((counter / 60).toString());
				let seconds: number = (counter - (minutes * 60));
				$("#timertext").text(minutes.toString() + ((seconds < 10 ? ":0" : ":") + seconds.toString()));
			}
			//all pages check session limits
			_idleCheck(_ticks_idle);
			_expiredCheck(_ticks_idle);

			//timed pages have time limits
			if (!isNaN(counter)) {
				_warn1Check(counter);
				_warn2Check(counter);
				_timeoutCheck(counter);
			}
		}, _pollInterval);
	}

	/** Initialize timer for new page countdown */
	function _init() {
		clearInterval(_timer);
		clearInterval(_autoSaveTimer);
		if (typeof $("#timer").data("idle-seconds") !== "undefined") {
			_startActivity = new Date();
			_ticks = 0;
			_ticks_idle = 0;
			_idleSeconds = Number($("#timer").data("idle-seconds"));
			_checkInterval();
		}
		_setPageTiming();

		/** Initialize auto save textarea */
		$("[data-autosave='true']").ready(function () {
			$("[data-autosave='true']").each(function (this: HTMLElement, index: number, element: HTMLElement) {
				_initAutoSaveTextarea($(this));
			});
		});
	}

	let _toggleDisplay = function () {
		_showTimerCount = !_showTimerCount;
		if (_showTimerCount) {
			$("#timerclock, #timertext").show();
		}
		else {
			$("#timertext").hide();
		}
	}

	/** Idle timeout warning 
	 * @param {number} ticks time on current view
	 */
	let _idleCheck = function (ticks: number) {
		if (ticks === _idleSeconds) {
			aptUtils.showModalDialog("", _idleMsg, 60);
		}
		else if (ticks >= _idleSeconds) {
			_idleSeconds = _idleSeconds + _idlePeriodSeconds; //participant closed modal, restart idle timer
		}
	}

	/** Expired session - Check for mobile device paused page 
	 * @param {number} ticks time on current view (polling)
	 */
	let _expiredCheck = function (ticks: number) {
		//get time on current view based on local clock
		let now: Date = new Date();
		let duration = now.getTime() - _startActivity.getTime();
		let pauseMinutes: number = 5;

		//Browsers may pause JS on inactive tabs - End session if paused longer than X minutes
		if (!_pageTimed) { pauseMinutes = 20; }
		if ((duration / 1000) > (ticks + (pauseMinutes * 60))) {
			clearInterval(_timer);
			console.info(`${now.toLocaleString()}: Timer expired (timer.ts)`)
			window.location.href = siteUrl.concat("/Logon/Exit?440");
		}
	}

	/** First warning of assessment time limit 
	 * @param {number} counter time remaining in assessment
	 */
	let _warn1Check = function (counter: number) {
		if (counter === _warn1_Seconds) {
			let minutes: number = counter / 60;
			aptUtils.showModalDialog("", _warn1Msg.replace("<TimeLeft>", minutes.toString()), 0);
		}
		if (counter <= _warn1_Seconds && counter > _warn2_Seconds) {
			$("#timerclock, #timertext").addClass("text-warning");
		}
	}

	/** Second warning of assessment time limit 
	 * @param {number} counter time remaining in assessment
	 */
	let _warn2Check = function (counter: number) {
		if (counter === _warn2_Seconds) {
			aptUtils.showModalDialog("", _warn2Msg, 0);
		}
		if (counter <= _warn2_Seconds) {
			if (counter > (_warn2_Seconds - 2)) { $("#timerclock, #timertext").removeClass("text-warning"); }
			$("#timerclock, #timertext").addClass("text-danger");
		}
	}

	/** Assessment time limit check 
	 * @param {number} counter time remaining in assessment
	 */
	let _timeoutCheck = function (counter: number) {
		if (counter <= 0) {
			const now = new Date()
			//time is up
			clearInterval(_timer);
			console.info(`${now.toLocaleString()}: Assessment time expired (timer.ts)`)

			window.location.href = siteUrl.concat("/TestTimeout/TestTimeout?WebID=", String($("#WebID").val()));
		}
	}

	/** Set standard timer settings on full page load */
	$(() => {
		if (typeof $("#timer").data("idle-seconds") !== "undefined") {
			_idlePeriodSeconds = Number($("#timer").data("idle-seconds"));
			_idleSeconds = _idlePeriodSeconds;
			_idleMsg = $("#timer").data("idle-message");
			_warn1_Seconds = Number($("#timer").data("warn1-seconds"));
			_warn1Msg = $("#timer").data("warn1-message");
			_warn2_Seconds = Number($("#timer").data("warn2-seconds"));
			_warn2Msg = $("#timer").data("warn2-message");
			$("#timerclock, #timertext").show();
			_init();
		}
	})

	let _setPageTiming = () => {
		if (_pageTimer) {
			clearInterval(_pageTimer);
			_pageTimer = 0;
		}
		if (window.location.pathname.toLowerCase().indexOf("survey") > -1) {
			_pageTimer = window.setInterval(_updatePageTiming, 60000);
		}
	}

	/** Record the time spent on page using an ajax call to the controller.
	 *  @function _updatePageTiming
	*/
	let _updatePageTiming = () => {

		if (typeof (navigator.sendBeacon) === "function")
			navigator.sendBeacon("UpdatePageTiming", new Blob([$("form").find('input:not([name="items"]').serialize()], { type: "application/x-www-form-urlencoded" }));
		else {
			let data: any = {
				WebID: apt.sm.webId,
				NodeNumber: apt.sm.getNodeNumber(),
				Duration: $("#Duration").val(),
				TimeRemaining: $("#TimeRemaining").val()
			};

			aptAjax.request({
				url: "UpdatePageTiming",
				data: data,
				type: "POST"
			});
		}
		const now = new Date()
		console.info(`${now.toLocaleString()}: Update page timing.`)

		_reset();
	}

	let _reset = () => {
		_ticks = 0;
		_setPageTiming();
	}

	/** Setup auto save textarea responses
	 * @function _autoSaveTextarea
	 * @param element {JQuery<HTMLElement>}
	 */
	let _initAutoSaveTextarea = function (element: JQuery<HTMLElement>) {

		let _itemNumber: number = element.data("item");
		let _autoSaveInterval: number = 30000; //How often to save text (in milliseconds)

		_autoSaveTimer = setInterval(_autoSave, _autoSaveInterval, apt.sm.getNodeNumber(), _itemNumber, element);
	}

	let _autoSave = function (nodeNumber: number, itemNumber: number, element: JQuery<HTMLElement>) {
		if (!nodeNumber || !itemNumber || !apt.sm.webId || !element.val()) { return; }
		const saveIcon = $(element).parent().find(".autosave-icon")
		const save = $(element).parent().parent().find(".autosave-label")

		aptAjax.request({
			url: "AutoSaveTextArea",
			data: {
				webID: apt.sm.webId, nodeNumber: nodeNumber, itemNumber: itemNumber, text: <string>element.val()
			}
		}).done(function (data: JsonData) {
			if (data.success) {
				save.fadeIn();
				saveIcon.fadeIn();
			}
			setTimeout(function () {
				save.fadeOut();
				saveIcon.fadeOut();
			}, 3000);
		});
	}

	return {
		init: _init,
		toggleDisplay: _toggleDisplay,
		updatePageTiming: _updatePageTiming
	}
})($);